import OrderOptimizerListParams, {
  OrderOptimizerListParamsStatus,
} from "../../../../../common/services/order-optimizer/list/order-optimizer-list-params";
import { OrderOptimizerRailyListingItemStatus } from "../../../../order-optimizer/raily/listing/common/types/order-optimizer-raily-listing-item";
import OrderDetailsManageDriverAssignmentOptitoolFilter from "./filters/types/order-details-manage-driver-assignment-optitool-filter";
import OrderDetailsManageDriverAssignmentOptitoolFilterType from "./filters/types/order-details-manage-driver-assignment-optitool-filter-type";

const createStatus = (
  status: OrderOptimizerRailyListingItemStatus,
): OrderOptimizerListParamsStatus => {
  switch (status) {
    case OrderOptimizerRailyListingItemStatus.INTERESTING:
      return OrderOptimizerListParamsStatus.INTERESTING;
    case OrderOptimizerRailyListingItemStatus.PENDING:
      return OrderOptimizerListParamsStatus.PENDING;
    case OrderOptimizerRailyListingItemStatus.REJECTED:
      return OrderOptimizerListParamsStatus.REJECTED;
  }
};

const create = (
  filters: OrderDetailsManageDriverAssignmentOptitoolFilter[],
  page: number,
  pageSize: number,
): OrderOptimizerListParams => {
  const ignoreDriverRoutes = filters.find(
    (filter) =>
      filter.type ===
      OrderDetailsManageDriverAssignmentOptitoolFilterType.IGNORE_DRIVER_ROUTES,
  )?.value as boolean | undefined;

  const ignoreTaxi = filters
    .filter(
      (filter) =>
        filter.type ===
        OrderDetailsManageDriverAssignmentOptitoolFilterType.IGNORE_TAXI,
    )
    .map((filter) => filter.value);

  const ignoreOnlyWithTaxi = filters
    .filter(
      (filter) =>
        filter.type ===
        OrderDetailsManageDriverAssignmentOptitoolFilterType.IGNORE_ONLY_WITH_TAXI,
    )
    .map((filter) => filter.value);

  const ignoreCargo = filters
    .filter(
      (filter) =>
        filter.type ===
        OrderDetailsManageDriverAssignmentOptitoolFilterType.IGNORE_CARGO,
    )
    .map((filter) => filter.value);

  const ignoreOnlyWithCargo = filters
    .filter(
      (filter) =>
        filter.type ===
        OrderDetailsManageDriverAssignmentOptitoolFilterType.IGNORE_ONLY_WITH_CARGO,
    )
    .map((filter) => filter.value);

  const statusFilter = filters.find(
    (filter) =>
      filter.type ===
      OrderDetailsManageDriverAssignmentOptitoolFilterType.STATUS,
  )?.value;

  return {
    page: page,
    pageSize: pageSize,
    orderHumanId: filters.find(
      (filter) =>
        filter.type ===
        OrderDetailsManageDriverAssignmentOptitoolFilterType.ORDER_HUMAN_ID,
    )?.value,
    maximumDelay: filters.find(
      (filter) =>
        filter.type ===
        OrderDetailsManageDriverAssignmentOptitoolFilterType.MAXIMUM_DELAY,
    )?.value as number | undefined,
    maximumHaltingTime: filters.find(
      (filter) =>
        filter.type ===
        OrderDetailsManageDriverAssignmentOptitoolFilterType.MAXIMUM_HALTING_TIME,
    )?.value as number | undefined,
    mergePlanEntries: ignoreDriverRoutes ? false : undefined,
    ignoreCargo: ignoreCargo,
    ignoreOnlyWithCargo: ignoreOnlyWithCargo,
    ignoreOnlyWithTaxi: ignoreOnlyWithTaxi,
    ignoreTaxi: ignoreTaxi,
    status:
      statusFilter && !statusFilter.exclude
        ? createStatus(statusFilter.status)
        : undefined,
    excludeStatus:
      statusFilter && statusFilter.exclude
        ? createStatus(statusFilter.status)
        : undefined,
  };
};

const orderDetailsManageDriverAssignmentOptitoolLoadParamsFactory = {
  create,
};

export default orderDetailsManageDriverAssignmentOptitoolLoadParamsFactory;
